"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

if ("variantDiscountedPrices" in window) {
  var newVariantDiscountedPrices = {};
  Object.keys(window.variantDiscountedPrices).forEach(function (key) {
    if (key.match(/\//)) {
      var keyArr = key.split("/");
      var variantId = keyArr[0];
      var minQty = parseInt(keyArr[1]);
      var newVariantDiscount = window.variantDiscountedPrices[key];
      newVariantDiscount.minQty = minQty;

      if (variantId in newVariantDiscountedPrices) {
        newVariantDiscountedPrices[variantId].push(newVariantDiscount);
      } else {
        newVariantDiscountedPrices[variantId] = [newVariantDiscount];
      }
    }
  });

  if (!(Object.keys(newVariantDiscountedPrices).length === 0 && newVariantDiscountedPrices.constructor === Object)) {
    // if object is not empty
    window.variantDiscountedPrices = newVariantDiscountedPrices;
    newVariantDiscountedPrices = undefined;
  }
} // noinspection JSUnusedGlobalSymbols


function u_cart(cart, options) {
  // noinspection JSUnresolvedVariable
  if (!cart.item_count || typeof variantDiscountedPrices == "undefined") {
    return cart;
  } // Attributes to update


  var itemPriceAttrToUpdate = "price";

  if (options && "itemPriceAttrToUpdate" in options) {
    itemPriceAttrToUpdate = options.itemPriceAttrToUpdate;
  }

  var cartTotal = 0;

  for (var i = 0; i < cart.items.length; i++) {
    // noinspection JSUnresolvedVariable
    if (cart.items[i].id in variantDiscountedPrices) {
      cart.items[i][itemPriceAttrToUpdate] = u_price(cart.items[i]);
      cart.items[i].final_price = cart.items[i][itemPriceAttrToUpdate];
      cart.items[i].line_price = cart.items[i].price * cart.items[i].quantity;
      cart.items[i].final_line_price = cart.items[i].line_price; // Comment 2 lines below to show original price on the cart page

      cart.items[i].original_price = cart.items[i].price;
      cart.items[i].original_line_price = cart.items[i].final_line_price;
    }

    cartTotal += cart.items[i].final_line_price;
  }

  cart.total_price = cartTotal;
  return cart;
}
/**
 * Returns lowest applicable price for the item passed as an argument. The price is based on customer discounts
 * retrieved from Unleashed. If no discounts found, the standard item price will be returned.
 * @param item Shopify product variant or cart line item object
 * @param qty Number of items, to get price based on quantity break. If not specified and cart item object passed then
 * item.quantity attribute will be used. Default value: 1
 * @returns int
 */


function u_price(item, qty) {
  qty = qty ? qty : item.quantity ? item.quantity : 1;

  if (!("variantDiscountedPrices" in window)) {
    throw new Error("variantDiscountedPrices variable not found");
  }

  if ((typeof variantDiscountedPrices === "undefined" ? "undefined" : _typeof(variantDiscountedPrices)) != "object") {
    throw new Error("variantDiscountedPrices should be an object but type is ".concat(typeof variantDiscountedPrices === "undefined" ? "undefined" : _typeof(variantDiscountedPrices)));
  }

  if (_typeof(item) != "object") {
    throw new Error("InvalidArgument: variant object expected but variable with a type of ".concat(_typeof(item), " passed"));
  }

  if (!item.hasOwnProperty("id")) {
    throw new Error("InvalidArgument: variant expected but `id` attribute is missing");
  }

  if (!(item.id in variantDiscountedPrices)) {
    return item.price;
  }

  variantDiscountedPrices[item.id].forEach(function (discount) {
    if (!("price_discounted" in discount)) {
      throw new Error("Discounted price not found in the `discount` object");
    }

    if (discount.minQty > 0 && qty < discount.minQty) {
      return;
    }

    if (discount.price_discounted < item.price) {
      item.price = discount.price_discounted;
    }
  });
  return item.price;
}

if ("cwCartHandler" in window && "cartJson" in window) {
  window.cwCartHandler(window.cartJson);
}
//# sourceMappingURL=u-discounted-prices.js.map